import React from "react";
import Modal from "./Modal";
import SpecList from "../SpecList";
import AddGif from "../../assets/img/ad.gif";
const ProductDetailsModal = ({ productModal }) => {
  if (productModal) {
    return (
      <Modal
        className={`product-view-modal modal fade bd-example-modal-lg-${productModal._id}`}
      >
        <div class="row">
          <div class="product-gallery col-10 col-md-10 col-lg-6">
            <div class="row">
              <div class="col-md-12 product-slier-details">
                <div id="product-view-model">
                  <div class="item">
                    <img
                      src={productModal.image}
                      class="img-fluid"
                      alt="Product Img"
                      style={{ height: 450, width: 200 }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-12 col-md-12 col-lg-6">
            <div class="product-details-gallery">
              <div class="list-group">
                <h1 class="list-group-item-heading product-title">
                  {productModal.name}
                </h1>
              </div>
              <SpecList productInfo={productModal} />
            </div>
          </div>
          <img src={AddGif} />
        </div>
      </Modal>
    );
  }
  return;
};

export default ProductDetailsModal;
